module.exports = __webpack_public_path__ + "web/img/mvp-bg1.15e276d2.png";